import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHospitals = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H14C13.0681 3 12.6022 3 12.2346 3.15224C11.7446 3.35523 11.3552 3.74458 11.1522 4.23463C11 4.60218 11 5.06812 11 6M3 18H12M17 12H21M17 8H21M8 10V14M6 12H10M6.2 6H9.8C10.9201 6 11.4802 6 11.908 6.21799C12.2843 6.40973 12.5903 6.71569 12.782 7.09202C13 7.51984 13 8.07989 13 9.2V17.8C13 18.9201 13 19.4802 12.782 19.908C12.5903 20.2843 12.2843 20.5903 11.908 20.782C11.4802 21 10.9201 21 9.8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V9.2C3 8.0799 3 7.51984 3.21799 7.09202C3.40973 6.71569 3.71569 6.40973 4.09202 6.21799C4.51984 6 5.0799 6 6.2 6Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHospitals;
